import { render } from "./UnilateralNonTrImportComponent.vue?vue&type=template&id=37cdf6aa&scoped=true"
import script from "./UnilateralNonTrImportComponent.vue?vue&type=script&lang=js"
export * from "./UnilateralNonTrImportComponent.vue?vue&type=script&lang=js"

import "./UnilateralNonTrImportComponent.vue?vue&type=style&index=0&id=37cdf6aa&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37cdf6aa"]])

export default __exports__